import { RenderHtml } from '../../../utils';
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
export const TOTAL_CELL_PADDING = 50;
export class TableComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.getColWidthStyle = (col, overridenColumnWidths) => {
            return { width: overridenColumnWidths[col] - TOTAL_CELL_PADDING };
        };
    }
    renderTableRow(row, idx) {
        const rowComp = row.map((cellContent, rowIndex) => React.createElement("td", { key: rowIndex, className: 'table-cell' },
            React.createElement(RenderHtml, { html: cellContent, className: 'rendered-html' })));
        return (React.createElement("tr", { key: idx, className: 'table-row content-row' }, rowComp));
    }
    render() {
        const props = this.props;
        const { headings, cells, columnWidths } = props.value;
        const tableHeading = headings.map((heading, idx) => (React.createElement("th", { key: idx, style: columnWidths ? this.getColWidthStyle(idx, columnWidths) : undefined, className: 'table-cell heading-cell' },
            React.createElement(RenderHtml, { html: heading, className: 'rendered-html' }))));
        const tableWrapperClasses = classNames([
            'table-wrapper',
            { 'overriden-width': !!columnWidths }
        ]);
        return (React.createElement("div", { className: classNames('component', 'table-component', this.props.direction), "data-component-type": 'table' },
            React.createElement("div", { className: tableWrapperClasses },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", { className: 'table-row heading-row' }, tableHeading)),
                    React.createElement("tbody", null, cells.map((row, idx) => this.renderTableRow(row, idx)))))));
    }
}
